import type { List, Platform } from "./types";

/** Normalize a scalar, array, or missing platform value to an array. */
export function asPlatforms(value: Platform | Platform[] | null | undefined): Platform[] {
    if (value == null) {
        return [];
    }
    return Array.isArray(value) ? value : [value];
}

/** Platforms implied by list `show*` flags, in wrap order: TikTok, Instagram, YouTube. */
export function showFlagPlatforms(list: Pick<List, "showTikTokLink" | "showInstagramLink" | "showYouTubeLink">): Platform[] {
    const next: Platform[] = [];
    if (list.showTikTokLink) next.push("TikTok");
    if (list.showInstagramLink) next.push("Instagram");
    if (list.showYouTubeLink) next.push("YouTube");
    return next;
}

/**
 * Unique union of a leftover scalar (if any) plus `extra`, extras appended in given order.
 * Already-array values are returned as-is (List platform wrap skips arrays).
 */
export function unionPlatforms(value: Platform | Platform[] | null | undefined, extra: Platform[]): Platform[] {
    if (Array.isArray(value)) {
        return value;
    }
    const next: Platform[] = [];
    if (typeof value === "string" && value.length) {
        next.push(value);
    }
    for (const platform of extra) {
        if (!next.includes(platform)) {
            next.push(platform);
        }
    }
    return next;
}

/** List `platform` for reads: arrays pass through; leftover scalars union `show*` flags. */
export function listPlatforms(list: Pick<List, "showTikTokLink" | "showInstagramLink" | "showYouTubeLink"> & { platform?: Platform | Platform[] | null }): Platform[] {
    return unionPlatforms(list.platform, Array.isArray(list.platform) ? [] : showFlagPlatforms(list));
}
